import { RiRefund2Fill } from "react-icons/ri";
import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.documentListItem()
    .schemaType(`cancellationPolicyModal`)
    .icon(RiRefund2Fill)
    .id(`cancellationPolicyModal`)
    .title(`Cancellation Policy Modal`);
